@if (topheadline | async; as item) {
  <div class="flucelvax-top-navigation">
    <!--desktop version-->
    <section class="product_common-banner flucelvax_common-banner desktop-banner d-md-block d-lg-block d-none d-sm-none">
      @if (item?.media) {
        <div class="simple-banner banner__component--responsive common-image">
          <img class="js-responsive-image" [attr.alt]="item.media?.altText"
            [attr.title]="item.media?.altText"
            [src]="getImage(item.media)">
          </div>
        }
      </section>
      <!--for flucelvax mobile top banner-->
      <section class="product_common-banner1 flucelvax_common-banner mobile-banner d-none d-sm-block d-md-none d-lg-none d-xl-none">
        @if (item?.media) {
          <div class="simple-banner banner__component--responsive">
            <img class="js-responsive-image" [attr.alt]="item.media?.altText"
              [attr.title]="item.media?.altText"
              [src]="getMobileImage(item.media)">
            </div>
          }
        </section>
      </div>
    }
